const init = e => {
    console.log('Running custom scripts...');

    // PLP load more
    function collectionLoadMore() {
        const loadMoreBtn = document.querySelector('.js-load-more');
        if(loadMoreBtn) {
            const totalPagesEl = document.querySelector('[data-total-pages]');
            const nextUrlEl = document.querySelector('[data-next-url]');
            const currentPageEl = document.querySelector('[data-current-page]');
            const nextPageEl = document.querySelector('[data-next-page]');
            let totalPages = +totalPagesEl.value;
            let nextUrl = nextUrlEl.value;
            let currentPage = +currentPageEl.value;
            let nextPage = +nextPageEl.value;

            jQuery('.js-load-more').on('click', function(){
                const $this = $(this);
                nextUrl = nextUrlEl.value;

                if (!totalPagesEl || !nextUrlEl || !currentPageEl || !nextPageEl) return;

                $this.attr('disabled', true);
                $this.find('[loader]').addClass('btn--loading');
                
                $.ajax({
                    url: nextUrl,
                    type: 'GET',
                    dataType: 'html',
                    success: function(responseHTML){
                        $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
                        $('[data-current-page]').val(nextPage);
                        nextPage++;
                        $('[data-next-page]').val(nextPage);
                        $('[data-next-url]').val($('[data-next-url]').val().replace(/page=[0-9]+/,'page='+nextPage));
                        window.history.pushState({"html":responseHTML.html,"pageTitle":responseHTML.pageTitle},"", nextUrl);
                        if (window.AOS) { AOS.refreshHard() }
                        document.dispatchEvent(new Event('plpMoreLoaded'));
                    },
                    error: function (jqXHR) {
                        console.log(jqXHR);
                    },
                    complete: function() {
                        currentPage++;
                        if(currentPage < totalPages) {
                            $this.attr('disabled', false); $this.find('[loader]').removeClass('btn--loading');
                        }
                        if(currentPage >= totalPages) {
                            $this.addClass('hide');
                        } 
                    }
                })
            });
            if(currentPage >= totalPages) {
                loadMoreBtn.classList.add('hide');
            } 
        }
    }
    collectionLoadMore();

    // PLP load previous
    function collectionLoadPrev() {
        const loadPrevBtn = document.querySelector('.js-load-prev');
        if(loadPrevBtn) {
            const prevUrlEl = document.querySelector('[data-prev-url]');
            const prevPageEl = document.querySelector('[data-prev-page]');
            let prevUrl = prevUrlEl.value;
            let prevPage = +prevPageEl.value;

            jQuery('.js-load-prev').on('click', function(){
                const $this = $(this);
                prevUrl = prevUrlEl.value;
                if ( !prevUrlEl || !prevPageEl) return;

                $this.attr('disabled', true);
                $this.find('[loader]').addClass('btn--loading');
                
                $.ajax({
                    url: prevUrl,
                    type: 'GET',
                    dataType: 'html',
                    success: function(responseHTML){
                        $('.grid--view-items').prepend($(responseHTML).find('.grid--view-items').html());
                        prevPage--;
                        $('[data-prev-page]').val(prevPage);
                        $('[data-prev-url]').val($('[data-prev-url]').val().replace(/page=[0-9]+/,'page='+prevPage));
                        window.history.pushState({"html":responseHTML.html,"pageTitle":responseHTML.pageTitle},"", prevUrl);
                        if (window.AOS) { AOS.refreshHard() }
                        document.dispatchEvent(new Event('plpMoreLoaded'));
                    },
                    error: function (jqXHR) {
                        console.log(jqXHR);
                    },
                    complete: function() {
                        if(prevPage >= 1) {
                            $this.attr('disabled', false); $this.find('[loader]').removeClass('btn--loading');
                            $this.removeClass('hide');
                        }
                        if(prevPage < 1) {
                            $this.addClass('hide');
                        } 
                    }
                })
            });
            if(prevPage < 1) {
                loadPrevBtn.classList.add('hide');
            } else {
                loadPrevBtn.classList.remove('hide');
            }
        }
    }
    collectionLoadPrev();

    // Filter popout button
    $(document).on('click', '.js-drawer-open-collection-filters-popout', (e) => {
        document.querySelector('.filter-popout').classList.toggle('active');
    });
}

document.addEventListener('DOMContentLoaded', init, false);
